import { getErrorMessage, isHttpStatus } from '@/lib/platform';
import { Icon, type IconName } from '@/components/ui/icon';

interface ErrorStateProps {
  error: unknown;
  title?: string;
  onRetry?: () => void;
  onSwitch?: () => void;
}

export function ErrorState({ error, title, onRetry, onSwitch }: ErrorStateProps) {
  const is404 = isHttpStatus(error, 404);
  const is403 = isHttpStatus(error, 403);

  const iconName: IconName = is404 ? 'search' : is403 ? 'shield' : 'alert';

  const heading = is404
    ? (title ?? 'Not found')
    : is403
      ? 'Access denied'
      : (title ?? 'Something went wrong');

  const description = is404
    ? 'The resource you requested could not be found.'
    : is403
      ? "You don't have permission to access this resource."
      : getErrorMessage(error);

  const showRetry = !is404 && !is403;
  const danger = !is404 && !is403;

  return (
    <div className="wb-empty">
      <div
        className="wb-empty-ico"
        style={
          danger
            ? {
                color: 'var(--danger)',
                background: 'color-mix(in oklab, var(--danger) 12%, var(--surface))',
              }
            : undefined
        }
      >
        <Icon name={iconName} size={32} />
      </div>
      <div className="wb-h2">{heading}</div>
      <div className="wb-sub" style={{ maxWidth: 330 }}>
        {description}
      </div>
      {(showRetry || onSwitch) && (
        <div className="wb-row wb-gap-8" style={{ marginTop: 16 }}>
          {showRetry && onRetry && (
            <button type="button" onClick={onRetry} className="wb-btn wb-btn--primary wb-btn--sm">
              <Icon name="refresh" size={18} />
              Try again
            </button>
          )}
          {onSwitch && (
            <button type="button" onClick={onSwitch} className="wb-btn wb-btn--ghost wb-btn--sm">
              Try another operator
            </button>
          )}
        </div>
      )}
    </div>
  );
}
